import { Injectable, EventEmitter } from '@angular/core';

@Injectable()
export class EventsBusService {
  public showTopBar: EventEmitter<boolean> = new EventEmitter<boolean>();

  public updateFeedback: EventEmitter<string> = new EventEmitter<string>();

  constructor() {//
  }

}



// WEBPACK FOOTER //
// /ng-app/src/app/shared/eventsBus.service.ts